export default __webpack_public_path__ + "img/move-to-back.83cebf4a.svg";